/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nftInvite.vue?vue&type=template&id=0a023ec2&scoped=true"
import script from "./nftInvite.vue?vue&type=script&lang=js"
export * from "./nftInvite.vue?vue&type=script&lang=js"
import style0 from "./nftInvite.vue?vue&type=style&index=0&id=0a023ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a023ec2",
  null
  
)

export default component.exports